import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=4dd8525b&scoped=true"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"
import style0 from "./leader.vue?vue&type=style&index=0&id=4dd8525b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8525b",
  null
  
)

export default component.exports